var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"main-wrapper"}},[_c('Header'),_c('NoSideBarMain')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }